export default __webpack_public_path__ + "static/media/brigosha_logo.1178290b.svg";